import * as ng from 'angular';
import 'bugsnag-js';

import './auth-interceptor.service';
import './error-interceptor.service';
import preload from '../preload';

const app = ng.module('e360');
app.config(configure);

async function configureDomain() {
   return await preload((values) => {
      localStorage.setItem('ls.apiDomain', values.apiDomain);
      localStorage.setItem('ls.bugSnagReleaseStage', values.bugSnagReleaseStage);
      localStorage.setItem('ls.defaultMediaDomain', values.defaultMediaDomain);
      localStorage.setItem('ls.deploymentName', values.deploymentName);
      localStorage.setItem('ls.enableBugSnag', values.enableBugSnag);
      localStorage.setItem('ls.googleApiKey', values.googleApiKey);
      localStorage.setItem('ls.joinVirtualDomain', values.joinVirtualDomain);
      localStorage.setItem('ls.qrDomain', values.qrDomain);
      localStorage.setItem('ls.rsvpRootDomain', values.rsvpRootDomain);
      localStorage.setItem('ls.selfRegRootDomain', values.selfRegRootDomain);
      localStorage.setItem('ls.appVersion', values.appVersion);
      localStorage.setItem('ls.angularVersion', ng.version.full);

      // api key for the "E360 Admin", different from key in EdcServerLib.Config
      Bugsnag.apiKey = '807fed30146d63208299fbdcf2a927df';
      Bugsnag.autoNotify = false;
      Bugsnag.metaData = {};
      Bugsnag.releaseStage = values.bugSnagReleaseStage;
      Bugsnag.appVersion = values.appVersion;
      Bugsnag.notifyReleaseStages = ['dev', 'staging', 'production'];
   });
}

configure.$inject = ['$httpProvider', '$locationProvider'];
export function configure($httpProvider:ng.IHttpProvider, $locationProvider:ng.ILocationProvider) {
   $httpProvider.interceptors.push('errorInterceptor');
   $httpProvider.interceptors.push('authInterceptor');

   // angular 1.6 changed default prefix to '!' such that URLs look like '!#/dashboard'
   // however much of the code base is hard coded to use '#/dashboard' URLs
   // see https://docs.angularjs.org/guide/migration#commit-aa077e8
   $locationProvider.hashPrefix('');

   // @see: http://www.boylesoftware.com/blog/angular-tip-using-the-xmlhttprequest-object/
   XMLHttpRequest.prototype.setRequestHeader = (function(sup) {
      return function(header, value) {
         if ((header === "__XHR__") && ng.isFunction(value))
            value(this);
         else
            sup.apply(this, arguments);
      };
   })(XMLHttpRequest.prototype.setRequestHeader);

   configureDomain();
}

// list of countries that have been populated in the database
app.constant('countries', require('../../../countries.json'));
